import React from "react";

const Hero = () => {
  return (
    <div className="container hero ">
      <div className="animate-1">
        <img src="/assets/images/capsule-1.svg" alt="capsule-1" />
      </div>
      <div className="animate-5 " style={{ left: "100px !important" }}>
        <img src="/assets/images/animate-2.svg" alt="capsule-1" />
      </div>
      <div className="row align-items-center justify-content-center">
        <div className="col-lg-12" style={{ overflow: "hidden" }}>
          <div
            className="text-center"
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            <img src="/assets/images/banner-log.svg" alt="banner-log" />
          </div>
          <h1
            className="pt-2 pb-2 text-center"
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            Experience Secure and <span> Efficient OTC Trading </span>on
            Ethereum and Solana.
          </h1>
          <p className="pb-2 pt-2" data-aos="zoom-in" data-aos-duration="1000">
            Simplify your large-scale trades with advanced features like partial
            completions, vesting schedules, and our unique referral system.
          </p>
          <div className="d-flex header-btn align-items-center pt-2 justify-content-center gap-3">
            <button
              className="gradient-btn"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              Get Started <img src="/assets/images/cheveron-right.svg" alt="" />
            </button>
            <button
              className="outline-btn"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              Learn more
            </button>
           
            <div className="animate-2">
              <img src="/assets/images/capsule-1.svg" alt="capsule-1" />
            </div>
            <div className="animate-4">
              <img src="/assets/images/animate-2.svg" alt="capsule-1" />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-2 mt-3">
              <img src="/assets/images/S4.svg" alt="S1" />
              <img src="/assets/images/S3.svg" alt="S1" />
              <img src="/assets/images/S2.svg" alt="S1" />
              <img src="/assets/images/S1.svg" alt="S1" />
            </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
